import { useContext } from 'react';
import { Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { UserContext } from '../../../../Ai2App';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import 'sweetalert2/dist/sweetalert2.css';
import { useUiStore, useTabSettings } from '../../../hooks';
import type { RootState } from '../../../../store';
import type { UserContextType } from '../types';
import { NavItem, createNavItems } from './NavbarLeft/';
import type { ActiveTabKey, NavbarLeftProps } from './NavbarLeft/types';
import BackToSearchItem from './NavbarLeft/BackToSearchItem';

const NavbarLeft = (props: NavbarLeftProps) => {
  const { closeInsightDetails } = useUiStore();
  const { activeItem, activeInsightsCnt, actionsCnt } = props;

  const { patientProfile } = useSelector(
    (state: RootState) => state.patientProfile,
  );
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const userContext = useContext(UserContext);
  const { userState, setUserState } = userContext as unknown as UserContextType;
  const tabSettings = useTabSettings();

  const handleSelection = (selection: ActiveTabKey) => {
    closeInsightDetails();
    if (userState.unsavedData) {
      Swal.fire({
        title: 'Unsaved Data',
        text: 'You have unsaved data. Do you want to continue?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          setUserState({ unsavedData: false });
          props.sendToParent(selection);
        }
      });
    } else {
      props.sendToParent(selection);
    }
  };

  // Check if actions feature is enabled
  const areActionsEnabled =
    selectedTenancy?.features?.actions?.enabled !== false;

  // Create navigation items using the utility function
  const navItems = createNavItems({
    patientProfile,
    tabSettings,
    handleSelection,
    activeInsightsCnt,
    actionsCnt,
    areActionsEnabled,
    permissionsSetup: selectedTenancy?.permissionsSetup,
    permissions: selectedTenancy?.userPermissions,
  });

  return (
    <aside className="navbarLeft-container">
      <Nav id="navbarLeft" className="flex-column">
        <BackToSearchItem />
        {navItems.map((navItem) => (
          <NavItem
            key={navItem.id}
            config={navItem}
            isActive={activeItem === navItem.id}
          />
        ))}
      </Nav>
    </aside>
  );
};

export { NavbarLeft };
